export default function Why() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-6ca62a0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
      data-id="6ca62a0"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e6b55dd"
          data-id="e6b55dd"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-967cca4 elementor-invisible elementor-widget elementor-widget-heading"
              data-id="967cca4"
              data-element_type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  Why Should You Hire Us?
                </h2>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-9adb56f elementor-widget elementor-widget-heading"
              data-id="9adb56f"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  We Live By These Rules
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
